import { useTranslation } from "react-i18next";

interface SharkTitleProps {
  title?: string;
}

const SharkTitle = ({ title }: SharkTitleProps) => {
  const { t } = useTranslation();

  const displayTitle = title || t("title.main");

  return (
    <div className="shark-title">
      <p className="shark-title__outline" aria-hidden="true">
        {displayTitle}
      </p>
      <h1 className="shark-title__fill">{displayTitle}</h1>
    </div>
  );
};

export default SharkTitle;
